/**
 * Hands ready-made File objects to the open composer as if the user had dropped
 * them (MessageBox listens and runs its normal validate + upload pipeline). Used by
 * voice actions that receive a capture on a claimed callId, which the composer's
 * own extension subscriptions deliberately ignore.
 */
export const CUSTOM_ATTACH_COMPOSER_FILES_EVENT = 'customAttachComposerFiles';

export interface CustomAttachComposerFilesDetail {
    files: File[];
    /** Shown beside the attachment (e.g. a capture fallback explanation). */
    notice?: string;
}

export interface CustomAttachComposerFilesEvent extends CustomEvent {
    detail: CustomAttachComposerFilesDetail;
}

export const dispatchCustomAttachComposerFiles = (
    files: File[],
    notice?: string
): boolean => {
    if (!files.length) {
        return false;
    }
    try {
        window.dispatchEvent(
            new CustomEvent<CustomAttachComposerFilesDetail>(
                CUSTOM_ATTACH_COMPOSER_FILES_EVENT,
                {detail: {files, notice}, bubbles: true, cancelable: true}
            )
        );
        return true;
    } catch (error) {
        console.error('Error dispatching composer files event:', error);
        return false;
    }
};
